<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">Leave Request</h1>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column">
          <input-field label="From" type="date" v-model="from" :valid="startDateValid" required></input-field>
        </div>
        <div class="column">
          <input-field label="To" type="date" v-model="to" :valid="endDateValid" required></input-field>
        </div>
        <div class="column">
          <input-field label="Employee Id" v-model="employeeId"></input-field>
        </div>
      </div>
      <hr />
      <div class="columns">
        <div class="column">
          <router-link class="button" to="/export">Back</router-link>
        </div>
        <div class="column has-text-right">
          <button class="button is-primary" @click="onClick" :disabled="!startDateValid || !endDateValid" :class="{'is-loading': loading}">Export</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "../../../http";
import moment from "moment";
export default {
  data() {
    return {
      from: "",
      to: "",
      employeeId: "",
      loading: false
    };
  },
  computed: {
    startDateValid() {
      return this.from !== ""
    },
    endDateValid() {
      return this.to !== ''
    }
  },
  methods: {
    onClick() {
      let component = this;
      component.loading = true;
      http
        .post("/request/leave/export", {
          from: component.from,
          to: component.to,
          employeeId: component.employeeId
        })
        .then(response => {
          let element = document.createElement("a");
          element.setAttribute(
            "href",
            `data:text/csv;charset=utf-8,${encodeURI(response.data)}`
          );
          element.setAttribute(
            "download",
            `${moment().format("YYYYMMDDHHmm")} - Leave Requests.csv`
          );
          element.click();
          document.body.removeChild(element);
          component.loading = false;
        })
        .catch(error => {
          console.error(error);
          component.loading = false;
        });
    }
  }
};
</script>
